import  { useState, useEffect,useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {  useIsFetching, useIsMutating } from "react-query";
import DatePicker, {registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import add_card from "../../assets/Images/add_card.png";
import add_card_white from "../../assets/Images/add_card_white.png";
import account_balance_black from "../../assets/Images/account_balance_black.svg";
import add_card_black from "../../assets/Images/add_card_black.svg";
import account_balance_white from "../../assets/Images/account_balance_white.png";
import account_balance from "../../assets/Images/account_balance.png";
import LoaderComponent from "../../components/LoaderComponent";
import showSubscriptionToast from "./SubscriptionToast";
import { useAsaSession,useIsLoading } from '../../services/AsaSessionServices';
import { useFintechLayouts, usePaymentMethodsMutation,searchSubscription } from '../../services/AsaApiServices';
import { useDispatch  } from "react-redux";
import {setPaymentCVV} from "../../redux/sessionSlice";
import ConfirmDialog from "../../components/ConfirmDialog ";
import { useTranslation } from "react-i18next";
import { AsaStateContext } from '../../components/AsaStateProvider'
import { value } from "dom7";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
const MONTHSDATE = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const DAYSDATE = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
registerLocale('es', {
        localize: {
            month: n => MONTHSDATE[n],
            day: n => DAYSDATE[n]
        },
       
    });


interface IPaymentMethodInput {
  isDefault: boolean;
  paymentMethodName: string | null;
  paymentType: string;
  routingNumber: string | null;
  accountNumber: string | null;
  ACHName: string | null;
  cardType: string | null;
  firstName: string | null;
  middleName: string;
  lastName: string;
  expirationDate: Date | null;
  cardNumber: string;
  cardHolderName: string;
  CVV: string | null;
  nickName: string;
}

interface IPaymentMethodError {
  cardNumber: string | null;
  expirationDate: string | null;
  cardHolderName: string | null;
  CVV: string | null;
  accountNumber: string | null;
  routingNumber: string | null;
  nickName: string | null;
}

const defaultInput: IPaymentMethodInput = {
  isDefault: true,
  paymentMethodName: null,
  paymentType: "",
  routingNumber: null,
  accountNumber: null,
  ACHName: null,
  cardType: null,
  firstName: null,
  middleName: "",
  lastName: "",
  expirationDate: null,
  cardNumber: "",
  cardHolderName: "",
  CVV: null,
  nickName: "",
};

const defaultError: IPaymentMethodError = {
  cardNumber: null,
  expirationDate: null,
  cardHolderName: null,
  CVV: null,
  accountNumber: null,
  routingNumber: null,
  nickName: null,
};
type CreditCardRequiredField = Extract<keyof IPaymentMethodInput, "cardNumber" | "expirationDate" | "CVV" | "cardHolderName">;
type BankAccountRequiredField = Extract<keyof IPaymentMethodInput, "routingNumber" | "accountNumber">;
const creditCardRequiredFields: CreditCardRequiredField[] = [
  "cardNumber",
  "expirationDate",
  "CVV",
  "cardHolderName"
];

const bankAccountRequiredFields: BankAccountRequiredField[] = [
  "routingNumber",
  "accountNumber"
];
const PaymentOption = ({ option, selectedOption, onClick, icon, alt,style,disabled, isDarkMode }
  :{option:string,selectedOption:string,onClick:()=>void,icon:string,
    alt:string,
    style:any,
    disabled:boolean,
    isDarkMode?:boolean}) => (
  <div
    className={`flex-1 p-2  h-[71px] flex items-center justify-center ${
      selectedOption === option
        ? "border-4"
        : ""
    } rounded-lg cursor-pointer`}
    onClick={disabled?(e)=>{}: onClick}
    style={style}
  >
    <img
      src={icon}
      className={`w-8 h-8 ${selectedOption === option ? "filter invert" : ""} ${disabled? "opacity-50 cursor-not-allowed" : ""}`}

      alt={alt}
      style={{ filter: !isDarkMode && selectedOption !== option ? "none" : undefined }}
    />
  </div>
);

const InputField = ({ id, label, value, error, onChange, type = "text", placeholder = "", isDarkMode }:
  {id:string,label:string,value:string | null,error:string | null , onChange:(val:any,field:string)=>void,type:string | undefined,placeholder:string, isDarkMode?:boolean }
) => {
  const themeBg = isDarkMode ? "#121212" : "#EBECF0";
  const themeText = isDarkMode ? "#FFFFFF" : "#111827";
  const borderEmpty = isDarkMode ? "rgba(255, 255, 255, 0.5)" : "#4E4E4E";
  const borderFilled = isDarkMode ? "#EBECF0" : "#000000";

  return (
    <div className="mb-10 relative flex-1">
      <label
        className={`absolute transition-all duration-300 ease-in-out transform left-2 px-1 font-poppins ${
          value
            ? "-top-2.5 scale-75 label-shrink-port"
            : error
              ? "top-[-10px] -translate-y-1/2 label-expand-port"
              : "top-1/2 -translate-y-1/2 label-expand-port"
        }`}
        htmlFor={id}
        style={{
          fontSize: error ? "1rem" : value ? "1.25rem" : "1rem",
          backgroundColor: themeBg,
          color: themeText
        }}
      >
        {label}
      </label>
      <input
        type={type}
        id={id}
        className={`mt-1 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0 sm:text-sm pt-2 pb-2 pl-3 pr-3 ${value ? "" : ""}`}

        style={{
          backgroundColor: themeBg,
          borderColor: value ? borderFilled : borderEmpty,
          color: themeText,
        }}
        value={value || ""}
        onChange={(e)=>onChange(e,id)}
        placeholder={placeholder}
      />
      {error && (
        <p className="text-left text-xs absolute" style={{ left: "10px", color: "#ef4444" }}>
          {error}
        </p>
      )}
    </div>
  );
}

const DatePickerField = ({ selected, onChange, error, minDate, isDarkMode }:
  {selected:Date | null,onChange:(date:Date)=>void,error:string | null,minDate:Date, isDarkMode?:boolean}
) => {
  const [isValue, setIsValue] = useState(false);
  const { t,i18n } = useTranslation();
  const themeBg = isDarkMode ? "#121212" : "#EBECF0";
  const themeText = isDarkMode ? "#EBECF0" : "#111827";
  const borderEmpty = isDarkMode ? "rgba(255, 255, 255, 0.5)" : "rgba(0,0,0,0.08)";
  const borderFilled = isDarkMode ? "#EBECF0" : "#111827";

  return (
  <div className="custom-date-picker-port relative mb-10 flex-1">
    <label
      className={`absolute transition-all duration-300 ease-in-out transform left-2 px-1 font-poppins ${
        (selected || isValue)
          ? "-top-2.5 scale-75 label-shrink-port"
          : error
            ? "top-[-10px] -translate-y-1/2 label-expand-port"
            : "top-1/2 -translate-y-1/2 label-expand-port"
      }`}
      htmlFor="expirationDate"
      style={{
        fontSize: (selected || isValue) ? "1.25rem" : "1rem",
        zIndex: 1,
        backgroundColor: themeBg,
        color: themeText
      }}
    >
      {t("expiration")}
    </label>
    <DatePicker
      id="expirationDate"
      selected={selected}
      onChange={onChange}
      minDate={minDate}
      dateFormat="MM/yyyy"
      placeholderText=""
      className={(isDarkMode? "custom-date-picker":
        (isValue ?"custom-date-picker-light":"custom-date-picker-light-empty") )
        +" mt-1 block w-full h-[55px] font-poppins rounded-md border-2 shadow-sm focus:ring-0 sm:text-sm pt-2 pb-2 pl-3 pr-3"}
      showMonthYearPicker
      onChangeRaw={(e) => { 
          //setIsValue(e?.target?.value?.length > 0);  
          setIsValue(e?.target?.value !== "");  
          
        }}  
      locale={i18n.language}
      
      
    />
    {error && (
      <p className="text-left text-xs absolute" style={{ left: "10px", color: "#ef4444" }}>
        {error}
      </p>
    )}
  </div>
);}

const FormButton = ({ label, onClick, style  }:
  {label:string,onClick:(val:any)=>void,style:any, isDarkMode?:boolean}
) => (
  <button
    className="w-full text-white py-3 font-poppins font-semibold rounded-md transition duration-300 focus:outline-none focus:ring-2 shadow-custom"
    style={style}
    onClick={onClick}
  >
    {label}
  </button>
);

export default function SubscriptionAddCreditCardScreen() {
  const { t } = useTranslation();
  const layout = useFintechLayouts();
  const [asastate, ] = useContext(AsaStateContext)
  const isDarkMode= asastate?.isDarkMode??false;
  const { data: session } = useAsaSession();

  const [isLoading, setIsLoading] = useIsLoading();

  const paymentMethodMutation = usePaymentMethodsMutation();
  
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = location;
  const paymentMethod = state?.payment;
  const returnurl = state?.returnurl;
  const locationUrl= new URL(window.location.href)

  
  const [formData, setFormData] = useState<IPaymentMethodInput>({ ...defaultInput });
  const [errors, setErrors] = useState<IPaymentMethodError>({ ...defaultError });
  const [errors1, setErrors1] = useState({ accountNumber: null, routingNumber: null });
  const dispatch = useDispatch();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const minDate = new Date();
  //const [selectedOption, setSelectedOption] = useState<string>(isStandAlone ? "card" : paymentMethod?.paymentType || "" );
  const [selectedOption, setSelectedOption] = useState<string>("" );
 const isStandAlone=asastate?.url?.toLowerCase().includes("addcreditcard");
  const zeroPageData= useMemo(() => {
     const page = session?.sessionPages?.find((page) => page.pageNumber === 0);
     if( page && page.pageData) {
       return JSON.parse(page.pageData.replace(/\\/g, ""));
     }
  }, [session]);
  
  useEffect(() => {
    AnalyticsService.track("Add Credit Card Viewed", AnalyticsAction.View, AnalyticsFeature.Payment);
  }, []);

  useEffect(() => {
    if (location.state && paymentMethod) {
      const paymentType = paymentMethod.paymentType === "CC" ? "card" : "ACH";
      setSelectedOption(paymentType);
      let formattedCardNumber = paymentMethod.cardNumber
        ? paymentMethod.cardNumber.replace(/-/g, "").slice(0, 16)
        : null;

      if (formattedCardNumber) {
        formattedCardNumber = formattedCardNumber.match(/.{1,4}/g)?.join("-") || "";
      }

      setFormData({
        ...defaultInput,
        ...paymentMethod,
        expirationDate: new Date(
          Number(paymentMethod.expirationYear),
          Number(paymentMethod.expirationMonth) - 1,
          1
        ),
        cardNumber: formattedCardNumber,
        cardHolderName: paymentMethod?.cardHolderName
      });
    }
    //test

    
  }, [location.state, session]);

  const handleInputChange = (e: any, fieldName: string) => {
    let value = e.target.value;

    if (fieldName === "cardNumber") {
      value = value.replace(/-/g, "").slice(0, 16);
      if (value.length > 0) {
        value = value.match(/.{1,4}/g)?.join("-") || "";
      }
    }

    setFormData((prev) => ({ ...prev, [fieldName]: value || null }));
    if(
        (
          (selectedOption === "card" && creditCardRequiredFields.includes(fieldName as CreditCardRequiredField))
          ||
          (selectedOption === "ACH" && bankAccountRequiredFields.includes(fieldName as BankAccountRequiredField))
         
        )
        && !!!value
      ) {
        
        setErrors((prev) => ({ ...prev, [fieldName]: t("requiredField", { field: t(fieldName) }) }));
      }
      else{
        setErrors((prev) => ({ ...prev, [fieldName]: null }));
      }

    //setErrors((prev) => ({ ...prev, [fieldName]: value ? null : t("requiredField", { field: t(fieldName) }) }));
  };

  const handleDateChange = (date: Date) => {
    setFormData((prev) => ({ ...prev, expirationDate: date }));
    setErrors((prev) => ({ ...prev, expirationDate: date ? null : t("requiredField", { field: t("expirationDate") }) }));
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if(paymentMethod){

     
      const searchBody={
        paymentMethodId: paymentMethod.paymentMethodId,
        subscriptionStatus: "Active",
      }
      try {
        setIsLoading(true);
        const affectedSubscription=await searchSubscription(asastate,searchBody)
        if( affectedSubscription && affectedSubscription.length > 0){
          setShowConfirmDialog(true);
          return;
        }
      }
      catch (error) {
        console.error("Error searching subscription:", error);
        showSubscriptionToast(t("errorSearchingSubscription"), true);
        
      }
      finally {
        setIsLoading(false);
      }
    }
    await handleFormSubmitConfirmed();
  }
  const handleFormSubmitConfirmed = async () => {
    
    
  const errorMessages = Object.values(errors)
    .filter((msg) => !!msg)
    .join("\r\n");

  if (errorMessages) {
    showSubscriptionToast(errorMessages, true);
    return;
  }
    const isCardSelected = selectedOption === "card";
    const paymentType = isCardSelected ? "CC" : "ACH";

    const expirationMonth = isCardSelected && formData.expirationDate
      ? String(formData.expirationDate.getMonth() + 1).padStart(2, "0")
      : null;
    const expirationYear = isCardSelected && formData.expirationDate
      ? String(formData.expirationDate.getFullYear())
      : null;

    if (isCardSelected && (!!!formData.CVV || isNaN(parseInt(formData.CVV)))) {
      showSubscriptionToast(t("cvvRequired"), true);
      return;
    }

    const paymentMethodName = isCardSelected
      ? `CC${formData.cardNumber?.slice(-4)}`
      : paymentMethod?.paymentMethodName;

    const dataToSend = {
      ...formData,
      paymentMethodID: location?.state?.payment?.paymentMethodID,
      paymentType,
      expirationMonth,
      expirationYear,
      expirationDate: undefined,
      cardNumber: isCardSelected ? formData.cardNumber.replace(/-/g, "") : null,
      paymentMethodName: paymentMethodName
    };

    try {
      await paymentMethodMutation.mutateAsync({ body: dataToSend, isUpdate: !!paymentMethod });
      AnalyticsService.track(
        paymentMethod ? "Credit Card Updated" : "Credit Card Added",
        AnalyticsAction.Click,
        AnalyticsFeature.Payment
      );
      dispatch(setPaymentCVV({ paymentMethodId: dataToSend.paymentMethodID, cvv: dataToSend.CVV }));
      if(isStandAlone){
        window.location.href = zeroPageData?.successDynamicLink??( asastate?.dynamicLink || "https://asavault.com");
      }
      else if (returnurl) {
        navigate(returnurl, { replace:true, state: { from: "addpaymethod", isUpdate: !!paymentMethod } });
      } else {

        navigate(-1);
      }
    } catch (error) {
      AnalyticsService.track("Credit Card Submit Error", AnalyticsAction.API_Result, AnalyticsFeature.Payment);
      showSubscriptionToast((error as Error)?.message, true);
    }
  };

  const handleBackClick = () => {
    if (isStandAlone) {
      if (zeroPageData && zeroPageData.backActionDynamicLink) {
         window.location.href = zeroPageData.backActionDynamicLink;
      } else  {
          window.location.href = asastate?.dynamicLink || "https://asavault.com";
      }

    }
    else if (!!returnurl ){
      navigate(returnurl, { replace:true});
    }
    else{
      navigate(-1);
    }
  }

  return (
    <div
      className={`h-screen flex flex-col items-center text-center pt-10 relative font-poppins`}
      style={{
        ...layout?.backGroundStyle,
        background: layout?.backGroundStyle?.background ?? (isDarkMode ? "linear-gradient(to bottom,#705AE2,#490C95)" : "#f3f4f6")
      }}
    >
      {showConfirmDialog && (
        <ConfirmDialog
          title={t("updatePaymentMethodTitle")}
          message={t("updatePaymentMethodMessage")}
          onCancel={() => {
          setShowConfirmDialog(false);
          
          }}
          onConfirm={() => {
          // Handle confirm logic here
          setShowConfirmDialog(false); // Close dialog after action
          handleFormSubmitConfirmed();
        }}
          isOpen={showConfirmDialog}
          confirmButtonText={t("update")}
          cancelButtonText={t("cancel")}
        />
      )}
      {isLoading && <LoaderComponent incomelayout={layout} />}
      <div className="absolute top-4 left-4 rounded-lg p-1 w-[40px] h-[40px] flex items-center justify-center">
        <img
          className="cursor-pointer w-[18px] h-[18px] mt-8"
          src={arrow_back_ios_new}
          alt={t("back")}
          onClick={handleBackClick}
        />
      </div>
      <h1 className="font-bold text-xl text-white" >
        {selectedOption === "" && t("selectPaymentMethod")}
        {selectedOption === "card" && (!!!paymentMethod ? t("addCreditCard") : t("editCreditCard"))}
        {selectedOption === "ACH" && (!!!paymentMethod ? t("addCheckingAccount") : t("editCheckingAccount"))}
      </h1>
      <div className="bg-[#EBECF0] dark:bg-[#121212] rounded-t-3xl shadow-md mt-10 w-full  p-6 flex-grow flex flex-col"
        >
        <div className="flex justify-center mb-6 space-x-4">
          <PaymentOption
            option="card"
            selectedOption={selectedOption}
            onClick={() => {
              setSelectedOption("card");
              setFormData({ ...defaultInput });
              setErrors({ ...defaultError });
              if(!!!paymentMethod){
                creditCardRequiredFields.forEach((field) => {
                  setErrors((prev) => ({ ...prev, [field]: t("requiredField", { field: t(field) }) }));
                })
              }
            }}
            icon={selectedOption === "card" ? add_card : selectedOption === "" ? add_card_white : add_card_black}
            alt={t("cardNumber")}
            style={layout?.buttonStyle}
            disabled={false}
            isDarkMode={isDarkMode}
          />
          <PaymentOption
            option="ACH"
            selectedOption={selectedOption}
            onClick={() => {
              setSelectedOption("ACH");
              setFormData({ ...defaultInput });
              setErrors({ ...defaultError });
            }}
            icon={selectedOption === "ACH" ? account_balance : selectedOption === "" ? account_balance_white : account_balance_black}
            alt={t("accountNumber")}
            style={layout?.buttonStyle}
            disabled={false}
            isDarkMode={isDarkMode}
          />
        </div>

        {selectedOption && (
          <form onSubmit={handleFormSubmit}>
            {selectedOption === "card" && (
              <>
                <InputField
                  id="cardNumber"
                  label={t("cardNumber")}
                  value={formData.cardNumber}
                  error={errors.cardNumber}
                  onChange={(e) => handleInputChange(e, "cardNumber")}
                  type="tel"
                  placeholder=""
                  isDarkMode={isDarkMode}
                />
                <div className="flex space-x-4 mb-8">
                  <DatePickerField
                    selected={formData.expirationDate}
                    onChange={handleDateChange}
                    error={errors.expirationDate}
                    minDate={minDate}
                    isDarkMode={isDarkMode}
                  />
                  <InputField
                    id="CVV"
                    label={t("cvv")}
                    value={formData.CVV}
                    error={errors.CVV}
                    onChange={(e) => handleInputChange(e, "CVV")}
                    type="password"
                    placeholder=""
                    isDarkMode={isDarkMode}
                  />
                </div>
                <InputField
                  id="cardHolderName"
                  label={t("cardHolderName")}
                  value={formData.cardHolderName}
                  error={errors.cardHolderName}
                  onChange={(e) => handleInputChange(e, "cardHolderName")}
                  type={"text"}
                  placeholder=""
                  isDarkMode={isDarkMode}
                />
                <InputField
                  id="nickName"
                  label={t("nicknameOptional")}
                  value={formData.nickName}
                  error={errors.nickName}
                  onChange={(e) => handleInputChange(e, "nickName")}
                  placeholder=""
                  type={"text"}
                  isDarkMode={isDarkMode}
                />
              </>
            )}
            {selectedOption === "ACH" && (
              <>
                <InputField
                  id="accountNumber"
                  label={t("accountNumber")}
                  value={formData.accountNumber}
                  error={errors1.accountNumber}
                  onChange={(e) => handleInputChange(e, "accountNumber")}
                  type="tel"
                  placeholder=""
                  isDarkMode={isDarkMode}
                />
                <InputField
                  id="routingNumber"
                  label={t("routingNumber")}
                  value={formData.routingNumber}
                  error={errors1.routingNumber}
                  onChange={(e) => handleInputChange(e, "routingNumber")}
                  type="tel"
                  placeholder=""
                  isDarkMode={isDarkMode}
                />
              </>
            )}
            <FormButton
              label={paymentMethod ? t("update") : t("save")}
              onClick={handleFormSubmit}
              style={layout?.buttonStyle}
              
            />
          </form>
        )}
      </div>
    </div>
  );
}